import request from './request';
import { orderData } from './interface';

export const getProvider = () =>
  request({
    url: '/provider/all',
    method: 'GET'
  });
export const getChannel = () =>
  request({
    url: '/channel/all',
    method: 'GET'
  });
export const getPayeeChannel = () =>
  request({
    url: '/generic/payment/methods/payee',
    method: 'GET'
  });

export const getLimitMoney = () =>
  request({
    url: '/order/recharge/limitAmt',
    method: 'GET'
  });

export const getMoneyButtonList = () =>
  request({
    url: '/order/recharge/amounts',
    method: 'GET'
  });

export const createOrder = (data: orderData) =>
  request({
    url: '/order/recharge',
    method: 'POST',
    data
  });

export const checkingOrder = ({ orderNo, token }) =>
  request({
    url: `/order/recharge/${orderNo}`,
    method: 'GET',
    headers: {
      'Access-Token': token
    }
  });
